import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectedPersonsPointDto } from 'app/dtos/person-point/selected-person-point';
import { PersonPointService } from 'app/services/models/person-point.service';
import { PersonService } from 'app/services/models/person.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-selected-person-point',
  templateUrl: './selected-person-point.component.html',
  styleUrls: ['./selected-person-point.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectedPersonPointComponent implements OnInit {

  personPointForm: FormGroup;
  person: any = {};
  date = new Date();
  date2 = moment().add(8, 'hours').toDate();
  persons: any[] = []
  constructor(public activeModal: NgbActiveModal,
    private personPointService: PersonPointService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private personService: PersonService) { }

  async ngOnInit() {
    this.personPointForm = this.fb.group({
      workDate: [null, Validators.required],  // Tarih alanı zorunlu
      startTime: [null, Validators.required], // Başlangıç saati zorunlu
      endTime: [null, Validators.required],   // Bitiş saati zorunlu
      personsId: [[], Validators.required],
      status: [null, [Validators.required]],      // Durum zorunlu
      dayType: [null, Validators.required], // Keep dayType if needed
      description: [null]
    });
    await this.getAllPersons();
  }

  async getAllPersons() {
    const data = await this.personService.getAllPersons(0, 1000, '', true);
    console.log(data);
    this.persons = data.persons.map(p => {
      return {
        fullName: `${p.name} ${p.lastName}`,
        ...p
      };
    });
  }

  public dateTimeOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: false,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y ',
    locale: Turkish,
    defaultDate: this.date
  };

  statusList: any[] = [
    { id: 2, name: "Hafta İçi Mesai" },
    { id: 3, name: "Hafta Sonu Mesai" },
    { id: 4, name: "Uzaktan Mesai" },
    { id: 5, name: "Telafi Çalışması" },
    { id: 6, name: "Destek Çalışması" },
    { id: 7, name: "Resmi Tatil" },
    { id: 1, name: "Normal Çalışma" },
  ];

  onDayTypeChange() {
    const dayType = this.personPointForm.get('dayType')?.value;
    const selectedDate = this.personPointForm.get('workDate')?.value?.[0];
    const selectedDay = new Date(selectedDate).toLocaleDateString('en-US', { weekday: 'long' });

    const workingDays = this.person?.personalAdditionalInfarmation?.workingDays;
    if (!workingDays || workingDays.length === 0) return;

    const matchedSchedule = workingDays.find(w => w.day === selectedDay);
    const fallbackSchedule = workingDays[0];
    const useFallback = !matchedSchedule;
    const daySchedule = matchedSchedule || fallbackSchedule;

    const [startHour, startMinute] = daySchedule.start.split(':').map(Number);
    const [endHour, endMinute] = daySchedule.end.split(':').map(Number);

    const startInMinutes = startHour * 60 + startMinute;
    const endInMinutes = endHour * 60 + endMinute;
    const duration = endInMinutes - startInMinutes;

    if (dayType === 'full') {
      // FULL: Eğer fallback kullanılıyorsa başlangıçtan itibaren süreyi ekle
      const baseTime = useFallback ? startInMinutes : endInMinutes;
      const finalEndMinutes = baseTime + duration;
      const finalEndHour = Math.floor(finalEndMinutes / 60) % 24;
      const finalEndMinute = finalEndMinutes % 60;

      this.personPointForm.patchValue({
        startTime: {
          hour: useFallback ? startHour : endHour,
          minute: useFallback ? startMinute : endMinute
        },
        endTime: {
          hour: finalEndHour,
          minute: finalEndMinute
        }
      });
    }

    if (dayType === 'half') {
      // HALF: Eğer fallback kullanılıyorsa başlangıçtan yarım süre ekle
      const halfDuration = Math.floor(duration / 2);
      const baseTime = useFallback ? startInMinutes : endInMinutes;
      const finalEndMinutes = baseTime + halfDuration;
      const finalEndHour = Math.floor(finalEndMinutes / 60) % 24;
      const finalEndMinute = finalEndMinutes % 60;

      this.personPointForm.patchValue({
        startTime: {
          hour: useFallback ? startHour : endHour,
          minute: useFallback ? startMinute : endMinute
        },
        endTime: {
          hour: finalEndHour,
          minute: finalEndMinute
        }
      });
    }

    if (dayType === 'manual') {
      let manualHour: number;
      let manualMinute: number;

      if (!useFallback) {
        // Seçilen güne ait çalışma saati varsa: bitiş saati kullanılacak
        [manualHour, manualMinute] = daySchedule.end.split(':').map(Number);
      } else {
        // Seçilen gün yoksa: ilk günün başlangıç saati kullanılacak
        [manualHour, manualMinute] = fallbackSchedule.start.split(':').map(Number);
      }

      this.personPointForm.patchValue({
        startTime: {
          hour: manualHour,
          minute: manualMinute
        },
        endTime: null
      });
    }

  }


  isFormValid(): boolean {
    const status = this.personPointForm.get('status')?.value;
    const workDate = this.personPointForm.get('workDate')?.value;
    const startTime = this.personPointForm.get('startTime')?.value;
    const endTime = this.personPointForm.get('endTime')?.value;

    // Eğer çalışma tarihi ve saatler doğruysa form geçerli sayılır
    return !!(this.personPointForm.valid && workDate && startTime && endTime);
  }

  closeModal(result: boolean = false) {
    this.activeModal.close(result);
  }



  async onSumbit() {
    if (this.personPointForm.valid) {
      const val = this.personPointForm.value;
      let workStart: Date;
      let workEnd: Date;

      const selectedDate = new Date(val.workDate); // Seçilen gün
      const startTime = val.startTime; // Örn: { hour: 18, minute: 0 }
      const endTime = val.endTime;     // Örn: { hour: 3, minute: 0 }

      // workStart oluştur
      workStart = new Date(selectedDate);
      workStart.setHours(startTime.hour, startTime.minute, 0, 0);

      // workEnd oluştur
      workEnd = new Date(selectedDate);
      workEnd.setHours(endTime.hour, endTime.minute, 0, 0);

      const startTotalMinutes = startTime.hour * 60 + startTime.minute;
      const endTotalMinutes = endTime.hour * 60 + endTime.minute;

      if (endTotalMinutes <= startTotalMinutes) {
        // Sadece günü ileri al, saatleri yeniden kur
        workEnd.setDate(workEnd.getDate() + 1);
      }

      // UTC'ye dönüştür
      workStart.setHours(workStart.getHours() + 3); // +3 saat ekleme
      workEnd.setHours(workEnd.getHours() + 3); // +3 saat ekleme

      let workRate: number | null = null;
      switch (val.status) {
        case 2: workRate = 150; break;
        case 3: workRate = 200; break;
        case 4: workRate = 100; break;
        case 6: workRate = 100; break;
        case 7: workRate = 200; break;
        default: workRate = null; break;
      }

      let overtimeHours: number | null = null;
      const allowedOvertimeStatuses = [2, 3, 4, 6, 7];
      if (allowedOvertimeStatuses.includes(val.status)) {
        const diffMs = workEnd.getTime() - workStart.getTime();
        overtimeHours = diffMs / (1000 * 60 * 60); // milisaniyeden saate
      }

      const requestPayload: SelectedPersonsPointDto = {
        selectedPersons: this.personPointForm.value.personsId.map(p => p.id),
        workStart: workStart,
        workEnd: workEnd,
        status: val.status,
        description: val.description,
        workRate: workRate,
        overtimeHours: overtimeHours
      };

      console.log("Final Payload:", requestPayload);

      try {
        const response = await this.personPointService.selectedPersonsPoint(requestPayload);

        if (response.status) {
          this.toastrService.success(response.message);
          this.personPointService.sendEvent(true);
          this.closeModal(true);
        } else {
          this.toastrService.error(response.message);
        }
      } catch (err) {
        console.error(err);
        this.toastrService.error('Bir hata oluştu.');
      }

    }
  }

}
